<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span color="primary" class="headline">Search</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" style="padding:50px">
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="parent"
                :items="itemsr"
                clearable
                dense
                chips
                small-chips
                label="main category"
                item-text="arabic_title"
                item-value="id"
                @change="loadData"
              ></v-autocomplete>
            </v-col>
            <!-- append-icon="mdi-magnify" -->

            <v-col cols="12" md="6">
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col> </v-row
        ></v-form>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="itemHeader"
      :items="items"
      :search="search"
      :loading="loading"
      :items-per-page="-1"
      class="elevation-1 "
    >
      <template v-slot:top>
        <v-toolbar flat class="mb-7">
          <v-toolbar-title>Pharmacy Sub Categories</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>

          <!-- add / edit item component -->
          <ItemForm
            @closeDialog="openDialog = false"
            @formSubmitted="formSubmitted"
            :formTitle="formTitle"
            :dialog="openDialog"
            :record="record"
            :collection="collection"
            v-if="openDialog"
            :categories="itemsr"
          />

          <v-btn
            color="primary"
            dark
            class="mb-2"
            @click="
              () => {
                record = null;
                formTitle = 'Add New Item';
                openDialog = true;
              }
            "
          >
            <v-icon small>mdi-plus</v-icon>
          </v-btn>

          <!-- delete item -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline"
                >Are you sure you want to delete this item?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm()"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.image="{ item }">
        <v-img
          v-if="item.category_image"
          width="40px"
          height="40px"
          :src="item.category_image.data.full_url"
        />
      </template>
      <template v-slot:item.ardesc="{ item }">
        <v-checkbox
          v-model="checkbox"
          v-if="item.arabic_description"
        ></v-checkbox>
      </template>
      <template v-slot:item.endesc="{ item }">
        <v-checkbox
          v-model="checkbox"
          v-if="item.english_description"
        ></v-checkbox>
      </template>
      <template v-slot:item.color="{ item }">
        <div
          v-if="item.color"
          v-bind:style="{
            borderRadius: '25px',
            width: '15px',
            height: '15px',
            background: item.color,
          }"
        />
      </template>
      <template
        v-slot:item.actions="{ item }"
        style="textAlign:right !important"
      >
        <v-icon color="primary" small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>

        <v-icon color="error" small class="mr-2" @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import ItemForm from "./comp/categoryForm";
import { mapActions, mapGetters } from "vuex";
import ApiService from "@/services/api.service";

export default {
  components: {
    ItemForm,
  },
  props: ["items", "itemsr", "itemHeader", "collection"],
  data() {
    return {
      search: null,

      checkbox: true,
      parent: null,
      loading: false,
      openDialog: false,
      dialogDelete: false,
      formTitle: "Add New Item",
      record: null,
    };
  },
  methods: {
    async loadData() {
      try {
        // this.loading = true;
        // // doce to load data ...
        // this.loading = false;
        // this.$emit("fetchData", `&filter[parent_category]=${this.parent}`);

        this.$emit("loadData", this.parent);
      } catch (error) {
        console.log(error);
      }
    },

    editItem(item) {
      this.record = item;
      this.formTitle = "Edit Record";
      // this.openEditDialog = true;
      this.openDialog = true;
    },

    deleteItem(record) {
      this.record = record;
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      try {
        this.loading = true;
        // await this.deleteCategory(this.record);
        const { data } = await ApiService.delete(
          `items/${this.collection}/${this.record.id}`
        );
        this.loading = false;
        this.closeDelete();
        let msg;
        msg = "deleted successfully";
        // }
        alert(msg);
        this.loadData();
      } catch (error) {
        console.log(error);
      }
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    formSubmitted(msg) {
      this.openDialog = false;
      alert(msg);
      this.loadData();
    },
  },
  mounted() {
    // this.loadData();
  },
};
</script>

<style></style>
